/* eslint-disable react/require-default-props */
import {
  Badge,
  Button,
  Col,
  Drawer,
  Form,
  message,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tabs,
} from 'antd'
import React, { useEffect, useState } from 'react'

import Icon from '@ant-design/icons'
import { AxiosResponse } from 'axios'

import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { tiposGerais, tryError } from '../../../services/Afins'
import { ItensPerUserLogged } from '../../../services/login/permissaoUsuarioLoado'
import { getRecomendaAtivos, TypeRecomendaAtivos } from '../../../services/recomendacao/ativos'
import {
  delCompatibilidadeAtivos,
  getCompatibilidadeAtivos,
  postCompatibilidadeAtivos,
  TypeCompatibilidadeAtivos,
} from '../../../services/recomendacao/compatibilidadeAtivos'
import { getDadosQuimicos, TypeDadosQuimicos } from '../../../services/recomendacao/dadosQuimicos'
import { getInsumos } from '../../../services/recomendacao/insumos'
import { getRecomendaTecnologia } from '../../../services/recomendacao/tecnologia'
import { pagination, propsPopconfirm } from '../../Default'
import Icons from '../../Icons'
import { Notification } from '../../notification'
import { InputsCompatibilidade } from '../../SelectCompatibilidade'
import { Container } from './styled'

interface TypesRecomendaTipos {
  visible: boolean
  onClose: (data: boolean) => void
  onResponse?: () => void
  permissions: ItensPerUserLogged
}

interface ListAtivos {
  label: string
  value: number
}

const FormCompatibilidadeAtivos: React.FC<TypesRecomendaTipos> = (props) => {
  const { visible, onClose, onResponse } = props
  const [tabSelect, setTabSelect] = useState<number>(1)
  const [codAtivo, setCodAtivo] = useState<number>(0)
  const [compatibilidade, setCompatibilidade] = useState({
    compativel: [],
    incompativel: [],
  })
  const [tipoSelectIncompatibilidade, setTipoSelectIncompatibilidade] = useState(0)

  const [disableInputCompati, setDisableInputCompati] = useState(true)

  const [dataAtivos, setDataAtivos] = useState([])

  const [inputNameCompati, setInputNameCompati] = useState('')
  const [form] = Form.useForm()

  const [visibleDrawer, setVisibleDrawer] = useState(false)
  const [teste, setTeste] = useState([])

  const hancleDrawerClose = () => {
    setVisibleDrawer(false)
    setTabSelect(1)
    setCodAtivo(0)
    setDisableInputCompati(true)
    setCompatibilidade({ compativel: [], incompativel: [] })
    form.resetFields()
    onClose(false)
  }
  // const handleSearchInput = async (value) => {
  //   const resp: AxiosResponse<TypeRecomendaAtivos> = await getRecomendaAtivos({
  //     codConta: true,
  //     pagination: 15,
  //     nome: value,
  //   });

  //   const dados: ListAtivos[] = resp.data.itens.map((ativos) => ({
  //     label: ativos.nome,
  //     value: ativos.cod,
  //   }));

  //   return dados;
  // };

  const  handleChanteCompatibilidade = async (value, codTipo) => {
    let resp: AxiosResponse<TypeRecomendaAtivos | TypeDadosQuimicos>
    switch (codTipo) {
      case 1:
        resp = await getInsumos({ pagination: 15, nome: value })
        break
      case 2:
        resp = await getRecomendaAtivos({
          codConta: true,
          pagination: 15,
          nome: value,
        })
        break
      case 3:
        resp = await getDadosQuimicos({
          pagination: 15,
          nome: value,
          codTipo: 6,
        })
        break
      case 4:
        resp = await tiposGerais(7, true, value)
        break
      case 5:
        resp = await getRecomendaTecnologia({ pagination: 15, nome: value })
        break
      default:
        resp = null
    }
    const dados: ListAtivos[] = resp.data.itens.map((ativos) => ({
      label: ativos.nome,
      value: ativos.cod,
    }))
    setTeste(dados)

    return dados
  }

  const listAtivos = async () => {
    const resp: AxiosResponse<TypeRecomendaAtivos> = await getRecomendaAtivos({
      pagination: -1,
    })
    setDataAtivos(resp.data.itens)
  }

  const handleChangeSearchInput = async (codAtivo) => {
    const resp: AxiosResponse<TypeCompatibilidadeAtivos> = await getCompatibilidadeAtivos({
      codAtivo,
    })

    const dados = {
      compativel: resp.data.itens.filter((com) => com.cod_tipo !== 2),
      incompativel: resp.data.itens.filter((inc) => inc.cod_tipo !== 1),
    }

    let compativel = []
    dados.compativel.forEach((compa) => {
      const { cod } = compa
      Object.entries(compa).forEach(([key, value]) => {
        if (
          (key === 'cod_insumo' && value !== null) ||
          (key === 'cod_ingrediente_ativo' && value !== null) ||
          (key === 'cod_grupo_quimico' && value !== null) ||
          (key === 'cod_cultura' && value !== null) ||
          (key === 'cod_tecnologia' && value !== null)
        ) {
          compativel = [...compativel, { tipo: key, value, cod }]
          return compativel
        }
      })
      compativel = compativel.map((data) => {
        if (data.tipo === 'cod_insumo' && data.value === compa.cod_insumo) {
          data.name = compa.insumo_nome
        }
        if (data.tipo === 'cod_ingrediente_ativo' && data.value === compa.cod_ingrediente_ativo) {
          data.name = compa.ingrediente_ativo_nome
        }
        if (data.tipo === 'cod_grupo_quimico' && data.value === compa.cod_grupo_quimico) {
          data.name = compa.grupo_quimico_nome
        }
        if (data.tipo === 'cod_cultura' && data.value === compa.cod_cultura) {
          data.name = compa.cultura_nome
        }
        if (data.tipo === 'cod_tecnologia' && data.value === compa.cod_tecnologia) {
          data.name = compa.tecnologia_nome
        }
        return data
      })
    })

    let incompativel = []
    dados.incompativel.forEach((incom) => {
      const { cod } = incom

      Object.entries(incom).forEach(([key, value]) => {
        if (
          (key === 'cod_insumo' && value !== null) ||
          (key === 'cod_ingrediente_ativo' && value !== null) ||
          (key === 'cod_grupo_quimico' && value !== null) ||
          (key === 'cod_cultura' && value !== null) ||
          (key === 'cod_tecnologia' && value !== null)
        ) {
          incompativel = [...incompativel, { tipo: key, value, cod }]
          return incompativel
        }
      })
      incompativel = incompativel.map((data) => {
        if (data.tipo === 'cod_insumo' && data.value === incom.cod_insumo) {
          data.name = incom.insumo_nome
        }
        if (data.tipo === 'cod_ingrediente_ativo' && data.value === incom.cod_ingrediente_ativo) {
          data.name = incom.ingrediente_ativo_nome
        }
        if (data.tipo === 'cod_grupo_quimico' && data.value === incom.cod_grupo_quimico) {
          data.name = incom.grupo_quimico_nome
        }
        if (data.tipo === 'cod_cultura' && data.value === incom.cod_cultura) {
          data.name = incom.cultura_nome
        }
        if (data.tipo === 'cod_tecnologia' && data.value === incom.cod_tecnologia) {
          data.name = incom.tecnologia_nome
        }
        return data
      })
    })
    setCompatibilidade({
      compativel,
      incompativel,
    })
  }

  const handleChangeTabSelect = (key) => {
    setTabSelect(Number(key))
    form.resetFields(['tipo'])
    setDisableInputCompati(true)
  }

  const handleRemoveCompatibilidadeAtivo = async (cod) => {
    try {
      const resp = await delCompatibilidadeAtivos(cod)

      if (resp.status === 200) {
        Notification({
          message:
            tabSelect === 1
              ? 'Compatibilidade removida com sucesso'
              : 'Incompatibilidade removida com sucesso',
          type: 'success',
        })
        handleChangeSearchInput(codAtivo)
        onResponse()
      }
    } catch (error) {
      tryError(error)
    }
  }

  const onFinish = async (data) => {
    try {
      delete data.tipo
      data.cod_tipo = tabSelect

      const resp = await postCompatibilidadeAtivos(data)

      if (resp.status === 201) {
        handleChangeSearchInput(codAtivo)
        Notification({
          type: 'success',
          message: 'Sucesso',
          descricao:
            tabSelect === 1
              ? 'Compatibilidade salva com sucesso'
              : 'Incompatibilidade salva com sucesso',
        })
        onResponse()
        form.resetFields(['tipo', inputNameCompati])
      }
    } catch (error) {
      message.destroy()
      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          Notification({
            type: 'error',
            message: 'Erro',
            descricao: data.error,
          })
        } else {
          data.error.forEach((data) => {
            Notification({
              type: 'error',
              message: 'Erro',
              descricao: data.msg[0],
            })
          })
        }
      }
    }
  }

  // useEffect(() => {
    
  //   if (tipoSelectIncompatibilidade > 0) {
  //     handleChanteCompatibilidade('', tipoSelectIncompatibilidade)
  //   }

  // }, [tipoSelectIncompatibilidade])

  useEffect(() => {
    setVisibleDrawer(visible)
  }, [visible])

  useEffect(() => {
    listAtivos()
  }, [])
  return (
    <Container>
      <Form form={form} onFinish={onFinish} layout='vertical'>
        <Drawer
          placement='left'
          style={{ position: 'absolute' }}
          size='large'
          getContainer={false}
          open={visibleDrawer}
          closeIcon={false}
          onClose={() => hancleDrawerClose()}
          footer={
            <Space>
              <Button type='primary' danger onClick={() => hancleDrawerClose()}>
                Fechar
              </Button>
            </Space>
          }
        >
          <Form.Item name='cod_ativo' label='Selecione um ativo'>
            {/* <SelectSearch
              fetchOptions={handleSearchInput}
              onChange={(data) => {
                handleChangeSearchInput(data?.value);
                setCodAtivo(data?.value);
              }}
            /> */}

            <Select
              showSearch
              allowClear
              onChange={(value) => {
                setCodAtivo(value)
                handleChangeSearchInput(value)
              }}
              filterOption={(input, option) =>
                String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {dataAtivos.map((data) => (
                <Select.Option key={data.cod} value={data.cod}>
                  {data.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Tabs
            className={tabSelect === 2 ? 'ant-incomatibilidade' : null}
            size='small'
            type='card'
            onChange={(key) => handleChangeTabSelect(key)}
          >
            <Tabs.TabPane
              key={1}
              tab={
                <>
                  Compatibilidades
                  <Badge offset={[10, -10]} count={compatibilidade.compativel.length} />
                </>
              }
            >
              <Row>
                <Space>
                  <InputsCompatibilidade
                    form={form}
                    disabled={disableInputCompati}
                    disableTipo={codAtivo <= 0}
                    fetchOptions={(search, cod) => handleChanteCompatibilidade(search, cod)}
                    cod={tipoSelectIncompatibilidade}
                    onChange={(value) => {
                      setTipoSelectIncompatibilidade(value)
                      setDisableInputCompati(false)
                    }}
                    onInputName={setInputNameCompati}
                    array={[
                      { label: 'Insumo', value: 1 },
                      { label: 'Ingrediente ativo', value: 2 },
                      { label: 'Grupo químico', value: 3 },
                      { label: 'Cultura', value: 4 },
                      { label: 'Tecnologia', value: 5 },
                    ]}
                  />
                  <Form.Item label=' '>
                    <Button htmlType='submit' type='primary'>
                      Inserir
                    </Button>
                  </Form.Item>
                </Space>
              </Row>
              <Col span={23}>
                <Table
                  size='small'
                  pagination={pagination}
                  dataSource={compatibilidade.compativel}
                  columns={[
                    {
                      key: 1,
                      dataIndex: 'tipo',
                      title: 'Tipo',
                      render: (data) => {
                        let name
                        switch (data) {
                          case 'cod_insumo':
                            name = 'Insumo'
                            break
                          case 'cod_ingrediente_ativo':
                            name = 'Ingrediente de ativo'
                            break
                          case 'cod_grupo_quimico':
                            name = 'Grupo químico'
                            break
                          case 'cod_cultura':
                            name = 'Cultura'
                            break
                          case 'cod_tecnologia':
                            name = 'Tecnologia'
                            break
                          default:
                            name = 'Não encontrado'
                            break
                        }
                        return <>{name}</>
                      },
                    },
                    { key: 2, dataIndex: 'name', title: 'Nome' },
                    {
                      key: 3,
                      dataIndex: 'cod',
                      width: 45,
                      title: 'Ações',
                      render: (cod) => (
                        <Popconfirm
                          {...propsPopconfirm}
                          title='Deseja remover essa compatibilidade?'
                          onConfirm={() => handleRemoveCompatibilidadeAtivo(cod)}
                        >
                          <Button
                            size='small'
                            danger
                            type='primary'
                            icon={<Icon component={() => <Icons icon={faTrash} />} />}
                          />
                        </Popconfirm>
                      ),
                    },
                  ]}
                />
              </Col>
            </Tabs.TabPane>
            <Tabs.TabPane
              key={2}
              tab={
                <>
                  Incompatibilidades
                  <Badge offset={[10, -10]} count={compatibilidade.incompativel.length} />
                </>
              }
            >
              <Row>
                <Space>
                  <InputsCompatibilidade
                    form={form}
                    disabled={disableInputCompati}
                    fetchOptions={(search, cod) => handleChanteCompatibilidade(search, cod)}
                    cod={tipoSelectIncompatibilidade}
                    onChange={(value) => {
                      setTipoSelectIncompatibilidade(value)
                      setDisableInputCompati(false)
                    }}
                    array={[
                      { label: 'Insumo', value: 1 },
                      { label: 'Ingrediente ativo', value: 2 },
                      { label: 'Grupo químico', value: 3 },
                      { label: 'Cultura', value: 4 },
                      { label: 'Tecnologia', value: 5 },
                    ]}
                  />
                  <Form.Item label=' '>
                    <Button htmlType='submit' type='primary'>
                      Inserir
                    </Button>
                  </Form.Item>
                </Space>
              </Row>
              <Col span={23}>
                <Table
                  size='small'
                  pagination={pagination}
                  dataSource={compatibilidade.incompativel}
                  columns={[
                    {
                      key: 1,
                      dataIndex: 'tipo',
                      title: 'Tipo',
                      render: (data) => {
                        let name
                        switch (data) {
                          case 'cod_insumo':
                            name = 'Insumo'
                            break
                          case 'cod_ingrediente_ativo':
                            name = 'Ingrediente de ativo'
                            break
                          case 'cod_grupo_quimico':
                            name = 'Grupo químico'
                            break
                          case 'cod_cultura':
                            name = 'Cultura'
                            break
                          case 'cod_tecnologia':
                            name = 'Tecnologia'
                            break
                          default:
                            name = 'Não encontrado'
                            break
                        }
                        return <>{name}</>
                      },
                    },
                    { key: 2, dataIndex: 'name', title: 'Nome' },
                    {
                      key: 3,
                      dataIndex: 'cod',
                      width: 45,
                      title: 'Ações',
                      render: (cod) => (
                        <Popconfirm
                          {...propsPopconfirm}
                          title='Deseja remover essa incompatibilidade?'
                          onConfirm={() => handleRemoveCompatibilidadeAtivo(cod)}
                        >
                          <Button
                            danger
                            size='small'
                            type='primary'
                            icon={<Icon component={() => <Icons icon={faTrash} />} />}
                          />
                        </Popconfirm>
                      ),
                    },
                  ]}
                />
              </Col>
            </Tabs.TabPane>
          </Tabs>
        </Drawer>
      </Form>
    </Container>
  )
}

export default FormCompatibilidadeAtivos
